import { render, staticRenderFns } from "./SelectedDetectionsActions.vue?vue&type=template&id=44a7d4f0&"
import script from "./SelectedDetectionsActions.vue?vue&type=script&lang=js&"
export * from "./SelectedDetectionsActions.vue?vue&type=script&lang=js&"
import style0 from "./SelectedDetectionsActions.vue?vue&type=style&index=0&id=44a7d4f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports